import React from 'react';
import PropTypes from 'prop-types';
import { HeadlinesWithRecommendationPrefill } from './headlines-with-recommendation-prefill';
import { LongHeadlinesWithRecommendationPrefill } from './long-headlines-with-recommendation-prefill';
import { DescriptionsWithRecommendationPrefill } from './descriptions-with-recommendation-prefill';

const TextAssetCollectionWithRecommendationPrefillInternal = (props) => {
  const {
    validationProps,
    withInlineRecommendations,
    fetchRecommendationAssets,
    cancelFetchRecommendationAssetsJob,
    isAudienceAd,
  } = props;

  const { data } = validationProps;
  const currentHeadlines = (data && data.Headlines) || '';
  const currentLongHeadlines = (data && data.LongHeadlines) || '';
  const currentDescriptions = (data && data.Descriptions) || '';

  return (
    <div className="text-asset-collections">
      <HeadlinesWithRecommendationPrefill
        currentData={currentHeadlines}
        isOptional={false}
        showDeleteButton={false}
        withInlineRecommendations={withInlineRecommendations}
        fetchRecommendationAssets={fetchRecommendationAssets}
        cancelFetchRecommendationAssetsJob={cancelFetchRecommendationAssetsJob}
        isAudienceAd={isAudienceAd}
      />
      <LongHeadlinesWithRecommendationPrefill
        currentData={currentLongHeadlines}
        isOptional={false}
        showDeleteButton={false}
        withInlineRecommendations={withInlineRecommendations}
        fetchRecommendationAssets={fetchRecommendationAssets}
        cancelFetchRecommendationAssetsJob={cancelFetchRecommendationAssetsJob}
      />
      <DescriptionsWithRecommendationPrefill
        currentData={currentDescriptions}
        isOptional={false}
        showDeleteButton={false}
        withInlineRecommendations={withInlineRecommendations}
        fetchRecommendationAssets={fetchRecommendationAssets}
        cancelFetchRecommendationAssetsJob={cancelFetchRecommendationAssetsJob}
      />
    </div>
  );
};

TextAssetCollectionWithRecommendationPrefillInternal.propTypes = {
  cancelFetchRecommendationAssetsJob: PropTypes.func.isRequired,
  fetchRecommendationAssets: PropTypes.func.isRequired,
  withInlineRecommendations: PropTypes.bool.isRequired,
  textAssetConfig: PropTypes.shape({
    headlines: PropTypes.shape({}),
    longHeadlines: PropTypes.shape({}),
    descriptions: PropTypes.shape({}),
  }),
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      Headlines: PropTypes.shape({}),
      LongHeadlines: PropTypes.shape({}),
      Descriptions: PropTypes.shape({}),
    }),
  }),
  isAudienceAd: PropTypes.bool.isRequired,
};

TextAssetCollectionWithRecommendationPrefillInternal.defaultProps = {
  textAssetConfig: {
    headlines: {},
    longHeadlines: {},
    descriptions: {},
  },
  validationProps: {
    data: {
      Headlines: {},
      LongHeadlines: {},
      Descriptions: {},
    },
  },
};

export const TextAssetCollectionWithRecommendationPrefill = TextAssetCollectionWithRecommendationPrefillInternal;
